import { useLang } from "hooks/useLang";
import { useState } from "react";
import Button from "components/Form/Button";
import { IoIosArrowDown } from "react-icons/io";
import PassTicketsLogo from "components/icons/PassTicketsLogo";
import { IoClose } from "react-icons/io5";

interface PrivateEventModalProps {
  open: boolean;
  onClose: () => void;
  onVerify: (code: string) => void;
  isLoading: boolean;
  errorMessage?: string;
}

const PrivateEventModal: React.FC<PrivateEventModalProps> = ({
  open,
  onClose,
  onVerify,
  isLoading,
  errorMessage,
}) => {
  const [code, setCode] = useState("");
  const { t, isAr, changeLanguage } = useLang();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#201750] bg-opacity-80">
        {/* Top Controls (Language + Close) */}
        <div className="absolute top-4 left-4">
          <button
            onClick={changeLanguage}
            className="px-3 py-1 rounded bg-transparent text-white hover:text-gray-300 transition"
          >
            {isAr ? "English" : "عربي"}
          </button>
        </div>
        <div className="absolute top-4 right-4">
          <button
            onClick={onClose}
            className="text-white text-2xl hover:text-gray-300"
          >
            <IoClose />
          </button>
        </div>
      </div>

      {/* Modal */}
      <div className="relative bg-[#3A2B87] rounded-2xl shadow-xl p-8 w-[90%] max-w-md text-center z-10">
        {/* Logo */}
        <PassTicketsLogo className="mx-auto mb-4 w-16" />
        {/* Title */}
        <h2 className="text-2xl font-bold mb-4 text-white">
          {t("private_event")}
        </h2>
        <p className="text-gray-200 mb-6">{t("private_event_desc")}</p>
        {/* Input */}
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          className="border border-white/20 rounded-lg px-4 py-3 w-full mb-3 bg-[#2C1F70] text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-mint-green-500"
          placeholder={t("enter_access_code")}
        />
        {/* Error */}
        {errorMessage && (
          <p className="text-red-400 text-sm mb-3">{errorMessage}</p>
        )}
        {/* Submit */}
        <Button
          onClick={() => onVerify(code)}
          disabled={code === "" || isLoading}
          className="bg-mint-green-500 hover:bg-mint-green-600 text-white px-6 py-3 mt-5 font-semibold w-full transition-all disabled:opacity-50"
        >
          {isLoading ? t("verifying") : t("submit")}
        </Button>
        <Button
          className="px-6 py-3 bg-transparent border-[#1DC2AB] w-full mt-5 text-white"
          theme="modern"
          onClick={onClose}
        >
          {t("browseEvents")}
          {/* <IoIosArrowDown className="ltr:-rotate-90 rtl:rotate-90 text-lg" /> */}
        </Button>
      </div>
    </div>
  );
};
export default PrivateEventModal;
